console.log('Custom JS loaded');

// Auto-generate Table of Contents for blog articles
document.addEventListener('DOMContentLoaded', function() {
  console.log('TOC script running');
  
  const article = document.querySelector('.article-template__content');
  const tocList = document.getElementById('toc-list');
  
  console.log('Article found:', article);
  console.log('TOC list found:', tocList);
  
  if (!article || !tocList) return;
  
  // Find all headings (h2, h3) in the article
  const headings = article.querySelectorAll('h2');
  console.log('Headings found:', headings.length);
  
  headings.forEach((heading, index) => {
    // Create an ID for the heading if it doesn't have one
    if (!heading.id) {
      heading.id = 'heading-' + index;
    }
    
    // Create TOC list item
    const li = document.createElement('li');
    const link = document.createElement('a');
    link.href = '#' + heading.id;
    link.textContent = heading.textContent;
    li.appendChild(link);
    tocList.appendChild(li);
  });
});
